import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ToastType } from "../../Components/Toast/Toast";
import { useToast } from "../../Components/Toast/ToastContext";
import { AccountDTO } from "../../Networking/Interface/Account/AccountInterface";
import { AccountSearch } from "./AccountSearch";
import { AccountViewNew } from "./AccountViewNew";
import { SunsetAPIAccountContext } from "../../Networking/Interface/Account/AccountAPIProvider";

/**
 * Drop-in replacement for AccountDashboard.
 * Uses the revamped AccountViewNew instead of AccountView.
 * To switch back, just change the import in App.tsx.
 */
export const AccountDashboardNew: React.FC = () => {
  const [selectedAcc, setSelectedAcc] = useState<AccountDTO | undefined>();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const onAccountSelect = (account: AccountDTO) => {
    setSelectedAcc(account);
    navigate(`/accounts/${account.id}/${account.username}`);
  };

  const { id, name } = useParams<{ id: string; name: string }>();
  const api = useContext(SunsetAPIAccountContext);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await api!.getAccountByIdAndName(
          parseInt(id!),
          name!
        );
        if (response.success && response.data) {
          if (
            selectedAcc?.id !== response.data.id ||
            selectedAcc?.username !== response.data.username
          ) {
            setSelectedAcc(response.data);
          }
        } else {
          showToast(
            ToastType.Error,
            "Failed to fetch the account. Please try again later.",
            10
          );
        }
      } catch {
        showToast(
          ToastType.Error,
          "You are likely being ratelimited, please wait.",
          5
        );
      }
    };

    if (
      id &&
      name &&
      (!selectedAcc ||
        selectedAcc.id.toString() !== id ||
        selectedAcc.username !== name)
    ) {
      fetchUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, name, api, selectedAcc]);

  return (
    <div className="account-wrapper">
      <AccountSearch onAccountSelect={onAccountSelect} />
      {!!selectedAcc && <AccountViewNew accountDTO={selectedAcc} />}
    </div>
  );
};

export default AccountDashboardNew;
